module.exports = __webpack_public_path__ + "img/17.e5a50421.png";